import { UNAUTHORIZED_POPUP_CLEAR } from "./UnauthorizedPopupActionTypes";

export const clearUnauthorizedPopupAction = () => (dispatch: any) => {
  dispatch({ type: UNAUTHORIZED_POPUP_CLEAR });
};
